import { render, staticRenderFns } from "./AtecoCodeTable.vue?vue&type=template&id=39c84b52&"
import script from "./AtecoCodeTable.vue?vue&type=script&lang=js&"
export * from "./AtecoCodeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports